import React from 'react';

interface ValidationIndicatorProps {
  isRequired: boolean;
  isValid: boolean;
}

const ValidationIndicator: React.FC<ValidationIndicatorProps> = ( { isRequired, isValid } ) => {
  return (
    <div
      className={`w-4 h-4 rounded-full absolute -top-2 -right-2 ${
        isRequired && !isValid ? 'bg-red-400 border-white border-2' : ''
      }`}
    />
  );
};

export default ValidationIndicator;
